import React from "react";
import { FormWrapper } from "./Contact.styles";
import {Container, Col, Row, Card} from "react-bootstrap";
import 'react-phone-number-input/style.css';
import { Link } from "gatsby";
import GetForm from "./GetForm";
import TestForm from "./TestForm";
import { FaHome } from "@react-icons/all-files/fa/FaHome"
import { FaPhone } from "@react-icons/all-files/fa/FaPhone"
import { FaEnvelope } from "@react-icons/all-files/fa/FaEnvelope"


const ContactForm = (props) => {

   
    return(
        <FormWrapper>
            <Container>
          <Row>
            <Col>
                <div className="contact-desc-text vertical_center">
                    <p>{props.subTitle}</p>
                    <div className="single-box">
                        <FaHome/>
                    <div className="desc"><span>Advanced Matrix </span> 
                        <span>Al Khobar, </span> 
                        <span>Kingdom of Saudi Arabia</span> </div>
                    
                    </div>
                    <div className="single-box"><FaPhone/> <div className="desc"><p>+966 138821464</p></div></div>
                    <div className="single-box"><FaEnvelope/> <div className="desc"><a href='mailto:info@itmatrix.com'>info@itmatrix.com</a></div></div>
                </div>
               
            </Col>
            <Col>
            <TestForm/>

            </Col>
          </Row>
        </Container>
               
           
        </FormWrapper>
    )
}
export default ContactForm;